<ng-container [ngSwitch]="deliveryMode">
  <span *ngSwitchCase="'DELIVERY'">Livraison</span>
  <span *ngSwitchCase="'PICKUP'">Ramassage</span>
  <span *ngSwitchCase="'REPRESENTATIVE'">Représantant</span>
</ng-container>